export default "__VITE_ASSET__BgfkaRzS__"